"use client";
import LoadingScreen from "@/components/LoadingScreen";
import { clearErrorMess, setSuccessMess } from "@/lib/features/statusSlice";
import { useAppDispatch, useAppSelector } from "@/lib/hooks";
import { ReducerType } from "@/lib/store";
import { Alert, Snackbar } from "@mui/material";

export const AppStatus = () => {
  const status = useAppSelector((state: ReducerType) => state.status);
  const disptach = useAppDispatch();

  return (
    <>
      {status.isLoading && <LoadingScreen />}
      <Snackbar
        open={!!status?.error}
        autoHideDuration={7000}
        onClose={() => disptach(clearErrorMess(undefined))}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={() => disptach(clearErrorMess(undefined))}
          severity="error"
        >
          {status?.error}
        </Alert>
      </Snackbar>
      <Snackbar
        open={!!status.success}
        autoHideDuration={7000}
        onClose={() => disptach(setSuccessMess(undefined))}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={() => disptach(setSuccessMess(undefined))}
          severity="success"
          sx={{
            backgroundColor: "var(--cimigo-green)",
            color: "#293306",
            fontWeight: 500,
          }}
        >
          {status?.success || "Thao tác thành công!"}
        </Alert>
      </Snackbar>
    </>
  );
};
export default AppStatus;
